var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cs-pic"}},[_c('div',{ref:"canvas",staticClass:"cornerstone-canvas cscanvas",on:{"cornerstonetoolsmouseclick":_vm.test}})])}
var staticRenderFns = []

export { render, staticRenderFns }